export default __webpack_public_path__ + "static/media/menu-mosaic.d11a4882.svg";